import { jsx as m } from "react/jsx-runtime";
import { c as w } from "react/compiler-runtime";
import { MapProvider as r } from "./MapContext.js";
import k from "./MapInitializer.js";
import { memo as y } from "react";
import { isEqual as h } from "lodash";
import { markersRenderEqual as C, circlesRenderEqual as G } from "./markerCompare.js";
import '../../../assets/index.css';const D = (e) => {
  const o = w(13);
  let t, i, a;
  o[0] !== e ? ({
    width: i,
    height: a,
    ...t
  } = e, o[0] = e, o[1] = t, o[2] = i, o[3] = a) : (t = o[1], i = o[2], a = o[3]);
  const c = i === void 0 ? "400px" : i, s = a === void 0 ? "400px" : a, d = t.showAddressInput ?? !0;
  let n;
  o[4] !== s || o[5] !== t.children || o[6] !== t.options || o[7] !== d || o[8] !== c ? (n = /* @__PURE__ */ m(k, { width: c, height: s, showAddressInput: d, options: t.options, children: t.children }), o[4] = s, o[5] = t.children, o[6] = t.options, o[7] = d, o[8] = c, o[9] = n) : n = o[9];
  let l;
  return o[10] !== t || o[11] !== n ? (l = /* @__PURE__ */ m(r, { ...t, children: n }), o[10] = t, o[11] = n, o[12] = l) : l = o[12], l;
}, T = y(D, (e, o) => {
  const t = C(e.markers, o.markers), i = G(e.circles, o.circles);
  if (!(e.selectedID === o.selectedID && e.zoom === o.zoom && e.mapType === o.mapType && e.enableCluster === o.enableCluster && e.markerDraggable === o.markerDraggable && e.overrideDrag === o.overrideDrag && e.hideTooltip === o.hideTooltip && e.showMetaDataTooltip === o.showMetaDataTooltip && e.showResetControl === o.showResetControl && e.showCurrentLocation === o.showCurrentLocation && e.showCenterMarker === o.showCenterMarker && e.mapDraggable === o.mapDraggable && e.doNotGenerateAddress === o.doNotGenerateAddress && e.width === o.width && e.height === o.height)) return !1;
  const c = h(e.options, o.options), s = h(e.geoJson, o.geoJson), d = typeof e.geoJsonStyle == "function" || typeof o.geoJsonStyle == "function" ? e.geoJsonStyle === o.geoJsonStyle : h(e.geoJsonStyle, o.geoJsonStyle), n = e.onGeoJsonClick === o.onGeoJsonClick, l = e.onGeoJsonHover === o.onGeoJsonHover, g = e.onGeoJsonHoverLeave === o.onGeoJsonHoverLeave, u = e.showAddressInput === o.showAddressInput, J = e.children === o.children, f = h(e.center, o.center);
  return t && i && c && s && d && n && l && g && u && J && f;
});
export {
  T as default
};
